import React, { useCallback, useState, useEffect } from "react";
import FundQuickDisplayRow from "../FundQuickDisplayRow.jsx";
import Button from "../Button.jsx";
import MaterialIcon from "../../elements/MaterialIcon.jsx";
import * as PropTypes from "prop-types";


export default function CategorySummaryTransactions({
	                                                    budget, budgetTransactions,
	                                                    isHighlighted,
	                                                    loan,
	                                                    renderTransactionSummary,
	                                                    shouldShowTransactionList,
	                                                    startAddTransaction,
                                                    }) {
	const [viewingTransactions, updateViewingTransactions] = useState(true);
	const showTransactions = () => {
		updateViewingTransactions(true);
	};
	if(!isHighlighted || !shouldShowTransactionList) {
		return null;
	}
	return (
		<div className=''>
			{false &&
			<FundQuickDisplayRow
				isLoan={loan}
				budget={budget}
			/>
			}
			<div className='transaction_summaries'>
				{!viewingTransactions &&
				<div className='row category_options_row'>
					<div className='col s12'>
						<React.Fragment>
							{!budget.isMultiBudget &&
							<div className='section'>
								<React.Fragment>
									<Button
										default
										flat
										onClick={showTransactions}
									>
										Show Transactions ({budgetTransactions.length})<MaterialIcon
										className='right'>arrow_drop_down</MaterialIcon>
									</Button>
								</React.Fragment>
							</div>
							}
						</React.Fragment>
					</div>
				</div>
				}
				{viewingTransactions &&
				<div className='row section'>
					{!budget.isMultiBudget &&
					<Button
						flat
						onClick={startAddTransaction}
						default
					>
						Add Transaction
					</Button>
					}
					{budgetTransactions.length === 0 &&
					<div>No Transactions To Show</div>
					}
					{budgetTransactions.map(renderTransactionSummary)}
				</div>
				}
			</div>
		</div>
	);
}

CategorySummaryTransactions.propTypes = {
	highlighted: PropTypes.any,
	loan: PropTypes.any,
	budget: PropTypes.any,
	viewingTransactions: PropTypes.bool,
	budgetTransactions: PropTypes.any,
	showTransactions: PropTypes.func,
	shouldShowTransactionList: PropTypes.any,
	startAddTransaction: PropTypes.func,
	renderTransactionSummary: PropTypes.func
};